import { IAdminInsightsResult } from '../types/IAdminInsightsResult';
import { Request } from './Request';

export class AdminInsightsDeleteProjectRequest
    extends Request<{}, IAdminInsightsResult> {

    constructor() {
        super('disableAdminInsights', {});
    }
}
